import toQueryString from "../utils/toQueryString";
import { apiGet } from "./helpers/api";
import { normalize, schema } from "normalizr";

const purchaseSchema = new schema.Entity("purchases");

export const fetchUserPurchases = (dispatch, { userId, page = 1 }) => {
  dispatch({ type: "USER_PURCHASES_FETCH_REQUESTED" });

  const searchQuery = toQueryString({ userIdEq: userId, s: "id+desc", subscriptionIdNull: 1 });

  return apiGet(`/api/v1/purchases?${searchQuery}&page=${page}&per_page=20`)
    .then(response => {
      dispatch({
        type: "USER_PURCHASES_FETCHED",
        payload: {
          ...normalize(response.body.data, [purchaseSchema]),
          pagination: {
            totalPages: response.body.totalPages,
            totalCount: response.body.totalCount,
            currentPage: response.body.currentPage,
          }
        }
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: "USER_PURCHASES_ERROR",
        payload: error.message
      });
      throw error;
    });
};

export const fetchProductPurchases = (dispatch, { productId, userId, page = 1 }) => {
  dispatch({ type: "PRODUCT_PURCHASES_FETCH_REQUESTED" });

  const searchQuery = toQueryString({ byProductId: productId, userIdEq: userId, s: "id+desc" });

  return apiGet(`/api/v1/purchases?${searchQuery}page=${page}`)
    .then(response => {
      dispatch({
        type: "PRODUCT_PURCHASES_FETCHED",
        payload: {
          ...normalize(response.body.data, [purchaseSchema]),
          productId,
          pagination: {
            totalPages: response.body.totalPages,
            totalCount: response.body.totalCount,
            currentPage: response.body.currentPage,
          }
        }
      });
      return response;
    })
    .catch(error => {
      dispatch({
        type: "PRODUCT_PURCHASES_ERROR",
        payload: error.message
      });
      throw error;
    });
};
